export default __webpack_public_path__ + "static/media/7minfitness_2.56bcd357.jpg";